import React from 'react'

function EmptyCart() {
    return (
        <div style={{ marginTop: "10rem" }}>
            <span style={{ fontSize: "3rem", fontWeight: "bolder" }}>
                Your cart is Empty
            </span>
        </div>
    )
}

export default EmptyCart
